/**
 * ¿Viene esta persona al login para CONTRATAR? (bloque 1 · C6a).
 *
 * La landing manda todos sus «Comienza ahora» a `/contratar?intent=contratar[&plan=…]`, y
 * `/contratar` sin sesión guarda ese destino completo antes de mandar al login
 * (`AlLoginConservandoDestino`). Con eso, el login puede hablarle a quien viene a crear una
 * cuenta —«Crea tu cuenta para comenzar», el código sin contraseña, el plan elegido— en vez de
 * enseñarle un «Inicia sesión» que suena a «esto no es para ti».
 *
 * Sin `intent=contratar` en el destino, la pantalla de siempre: un enlace viejo o alguien que
 * entra a su cuenta no ve el texto de alta.
 *
 * El plan es el MISMO que marcará /contratar (`planInicial`), para que el resumen del login y la
 * tarjeta seleccionada después no puedan contradecirse.
 *
 * CommonJS y pura para probarla desde `functions/__tests__`.
 */
const { planInicialConOrigen } = require('./planInicial');

/**
 * @param {{ruta?: string|null, atribucion?: object}} entrada
 *   ruta        el destino guardado (`verDestino()`), p. ej. `/contratar?intent=contratar&plan=pro`
 *   atribucion  `getAttribution()`
 * @returns {{contratar: false, plan: null} | {contratar: true, plan: 'starter'|'pro'}}
 */
function intencionDeAcceso({ ruta, atribucion } = {}) {
  const NINGUNA = { contratar: false, plan: null, elegido: false };
  if (typeof ruta !== 'string') return NINGUNA;
  const q = ruta.indexOf('?');
  const camino = q === -1 ? ruta : ruta.slice(0, q);
  const search = q === -1 ? '' : ruta.slice(q);
  if (camino !== '/contratar') return NINGUNA;
  let intent = null;
  try { intent = new URLSearchParams(search).get('intent'); } catch { intent = null; }
  if (intent !== 'contratar') return NINGUNA;
  const { plan, elegido } = planInicialConOrigen({ search, atribucion });
  return { contratar: true, plan, elegido };
}

module.exports = { intencionDeAcceso };
